/*
 * @Author: amywulan
 * @Date: 2021-07-Mo 11:41:54
 * @Last Modified by:  amywulan
 * @Last Modified time: 2021-07-Mo 11:41:54
 * @description: 路由入口文件
 */
import Vue from 'vue'
import Router from 'vue-router'
import maps from './map'
import { getLocale } from '@/utils/locale'
import { urlParamsSymbolChange, setTitle } from '@/utils/routerUrlTransform'
import { routerRedirectCatch } from '@/utils/routerRedirectCatch'
import { getDeepLinkBannerDDLCode } from './beforeEach/get-deeplink-banner-ddlcode'
Vue.use(Router)
// 解决 router A重定向到B，B直接重定向到C时报错的问题或者降级vueRouter版本到3.0.7
routerRedirectCatch(Router)

const router = new Router({
  routes: maps,
  mode: 'history',
  base: `${getLocale()}/food/`,
  scrollBehavior(to, from, savedPosition) {
    if (to?.name === from?.name && to?.meta?.unScrollTop) {
      return false
    } else {
      return { x: 0, y: 0 }
    }
  },
})

router.beforeEach((to, from, next) => {
  // url  统一增加promotionChannel
  // 去除空格 加号 反斜杠 等符号 转换为_  目前只有store页需要
  urlParamsSymbolChange(to, from, next)
})
router.beforeEach((to, from, next) => {
  // 修改 document.title
  setTitle(to, from, next)
})

/**
 * 路由钩子处理函数，后续相关路由拦截可以收敛到此处
 */
router.beforeEach((to, from, next) => {
  try {
    getDeepLinkBannerDDLCode(to, from, next)
  } catch (error) {
    console.error('[RouterBeforeEachHookError]:', error)
    next()
  }
})

// 在 router.beforeEach 中使用
router.beforeEach((to, from, next) => {
  // url中的参数
  const currentParams = new URLSearchParams(window.location.search)
  const jumpLinkType = currentParams.get('jumpLinkType')
  // 如果路径中不包含 Locale，则补全并重定向，且是从帮助中心来的(jumpLinkType=web)
  if (to.path.split('/')[1] === 'food' && jumpLinkType === 'web') {
    // 获取url中query参数重的locale并拼接
    const locale = currentParams.get('locale') || getLocale() || 'es-MX' // 获取当前的 locale
    console.log('router-locale', locale)
    const newPath = `/${locale}/food${to.path.replace(/^\/food/, '')}`
    const currentQuery = window.location.search
    // 拼接目标路径和当前 query
    const newUrl = newPath + currentQuery
    // 执行跳转
    window.location.replace(newUrl)
  } else {
    next() // 正常放行
  }
})
export default router
